import React from 'react'
import {Typography,Input,Button} from 'antd'
function ProductOverview(props) {
    const { Title,Text} = Typography
    return (
        <div className='upload-media-container'><div className='header-section'>
            <Title level={4}>Product Overview</Title>
            <Button type="primary" onClick={()=>{
                props?.editproductdata()
            }}>Save Changes</Button>
        </div>
        <div className='product-detail-view'>
            {
                props?.productsConfig?.fields?.map(item=>{
                    return <div className='single-product-view'>
                         <Text>{item?.title}</Text>
                         <Input placeholder='' value={props?.selectedProduct?.[item.name]}
                         onChange={(e)=>{
                             props?.addProductInfo(item?.name,e?.target?.value)

                         }}>{}</Input>
                    </div>
                })
            }
            </div>
        </div>
    )
}

export default ProductOverview
